import React from "react";
import { Container, Row, Col } from "reactstrap";
import heroImg from "../../assests/images/hero-img1.png";
import gifImage from "../../assests/images/.gif/giphy.gif";
import gifImage1 from "../../assests/images/.gif/giphy-1.gif";
import gifImage2 from "../../assests/images/.gif/giphy-5.gif";
import "./hero-section.css";

const HeroSection = () => {
  return (
    // арқасында оқушыларыңызға физиканы үйренуге мүмкіндік беріңіз-теория мен практиканы бір қызықты сабаққа біріктіріңіз!"
    <section>
      <Container className="container-hero-section">
        <Row>
          <Col lg="6" md="6">
            <div className="hero__content">
              <h2 className="mb-4 hero__title">
              Физика сабағында Python бағдарламалау тілін қолданудың мүмкіндіктері 
              </h2>
              <p className="mb-5 hero-title-desc" style={
                {
                  fontSize: '1.3em',
                  color: '#ffffff',
                }
              }>
              Python бағдарламалау тілінің арқасында оқушыларыңызға 
              <br />  
              физиканы үйренуге 
              мүмкіндік беріңіз, теория 
              <br />  мен практиканы бір қызықты сабаққа біріктіріңіз.
              </p>
            </div>
            {/* <div className="search">
              <input type="text" placeholder="Жазу ..." />
              <button className="btn">Іздеу</button>
            </div> */}
          </Col>

          <Col lg="6" md="6" className="col-hero-img">
            <img style={
              {
                borderRadius: '50px',
                marginTop: '50px',
                // marginLeft: '12px',
              }
            } src={gifImage1} alt="" className="w-100 hero__img" />
          </Col>
        </Row>
      </Container>
    </section>
  );
};

export default HeroSection;
